/** @file Cursor and change-tracking state shared by the buildRender writers during one pass. */
import { RENDER_LAYOUT } from '../renderBuffers';

/** Cursors, change flags, running bounds and the open draw of one buildRender pass. */
export interface BuildState {
  /** Vertices written so far. */
  v: number;
  /** Indices written so far. */
  i: number;
  /** Draw rows written so far (the open draw is not counted until flushed). */
  d: number;
  /** Run rows written so far. */
  r: number;
  /** A vertex, index, draw or run word differs from the previous contents. */
  changed: boolean;
  /** An index, draw or run word differs from the previous contents. */
  topo: boolean;
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
  /** Open draw [page, blend, indexStart, indexCount, vertexStart, vertexCount]; page -1 = none open. */
  draw: Int32Array;
}

/** A fresh state: zero cursors, no changes, empty bounds (±Infinity), no open draw. */
export function createBuildState(): BuildState {
  const draw = new Int32Array(RENDER_LAYOUT.DRAW_STRIDE);
  draw[0] = -1;
  return { v: 0, i: 0, d: 0, r: 0, changed: false, topo: false, minX: Infinity, minY: Infinity, maxX: -Infinity, maxY: -Infinity, draw };
}
